import styled from 'styled-components';

export const ResourcesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
`;
export const ResourcesIntro = styled.div`
  max-width: 760px;

  margin-bottom: var(--space-xxl);

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.8;
    font-weight: 500;
  }

  @media screen and (max-width: 600px) {
    margin-bottom: var(--space-xl);
  }
`;
export const ResourcesGroup = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--space-l);

  margin-bottom: var(--space-xxxl);

  &:last-child {
    margin-bottom: 0;
  }
`;
export const GroupHeader = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--space-xxs);

  h3 {
    margin: 0;

    color: var(--grey7);

    font-size: 1.4rem;
    line-height: 1.2;
    font-weight: 800;
  }

  span {
    color: var(--grey4);

    font-size: 0.95rem;
    line-height: 1.6;
    font-weight: 500;
  }
`;
export const ResourceRow = styled.a`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: var(--space-m);

  padding: var(--space-l);

  border-radius: 18px;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(249, 250, 251, 0.96) 100%
  );

  border: 1px solid rgba(15, 23, 42, 0.06);

  text-decoration: none;

  transition:
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;

  .left {
    display: flex;
    align-items: center;

    gap: var(--space-m);

    min-width: 0;
  }

  .resourceIcon {
    color: var(--orange5);

    font-size: 1rem;

    flex-shrink: 0;
  }

  span {
    color: var(--grey6);

    font-size: 1rem;
    line-height: 1.4;
    font-weight: 700;
  }

  .arrowIcon {
    color: var(--grey3);

    font-size: 0.9rem;

    flex-shrink: 0;

    transition:
      transform 0.2s ease,
      color 0.2s ease;
  }

  &:hover {
    border-color: rgba(230, 139, 7, 0.14);

    transform: translateY(-1px);

    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);

    .arrowIcon {
      color: var(--orange5);

      transform: translate(2px, -2px);
    }
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-m);

    .left {
      gap: var(--space-s);
    }

    span {
      font-size: 0.94rem;
    }
  }
`;
// export const EachProvince = styled.li`
//   list-style-type: none;
//   width: 45%;
//   padding: ${({ theme }) => theme.spacing.m};
//   text-align: center;
//   height: 10%;
//   a {
//     color: ${({ theme }) => theme.colors.grey5};
//   }
//   @media screen and (width <= 768px) {
//     width: 100%;
//   }
// `;

export const SectionContainer = styled.section`
  margin-top: var() (--space-l);
  h3 {
    color: ${({ theme }) => theme.colors.grey5};
    font-weight: 600;
    margin-bottom: var(--space-m);
  }
`;
